export const DialogSize = Object.freeze({
    small: "25rem",
    medium: "50rem",
    large: "80vw",
    customSize: (size) => {
        return size;
    },
});
